export const coaToNumber = (formattedCOA) => {
  const coa = typeof formattedCOA === 'object' ? formattedCOA : formattedCOA.split('.')

  let coaNumber = ''
  for (const v in coa) {
    coaNumber += Array.isArray(coa) ? coa[v - 1] : coa[v]
  }

  return Number(coaNumber)
}

export const splitCOANumber = (noCOA) => {
  const noCOAStr = noCOA.toString()
  return {
    1: noCOAStr.slice(0, 3),
    2: noCOAStr.slice(3, 5),
    3: noCOAStr.slice(5, 7),
    4: noCOAStr.slice(7, 9)
  }
}

export const formatCOANumber = (noCOA) => {
  const coaSegment = typeof noCOA === 'object' ? noCOA : splitCOANumber(noCOA)
  return `${coaSegment[1]}.${coaSegment[2]}.${coaSegment[3]}.${coaSegment[4]}`
}

export const getCurrentCOACategory = (coa) => {
  const {
    category_1: cat1,
    category_2: cat2,
    category_3: cat3,
    category_4: cat4
  } = coa

  if (cat1 && !cat2 && !cat3 && !cat4) {
    return 1
  } else if (cat1 && cat2 && !cat3 && !cat4) {
    return 2
  } else if (cat1 && cat2 && cat3 && !cat4) {
    return 3
  } else {
    return 4
  }
}

export const incrementCOA = (noCOA, category) => {
  const coaSegment = splitCOANumber(noCOA)
  const currentSegment = Number(coaSegment[category])

  let segmentTemp
  if (category > 1) {
    if (currentSegment < 10) {
      segmentTemp = (currentSegment + 1).toString().padStart(2, '0')
    } else {
      segmentTemp = currentSegment + 1
    }
  }

  coaSegment[category] = segmentTemp

  return coaToNumber(coaSegment)
}
